import {Facturacion} from '../interfaces/facturacion.interface'

export const facturacionInitialState: Facturacion = {
  formCliente: {
    fecha: new Date().toLocaleDateString('en-CA'),
    tipoDocumento: '',
    nombreTipoDocumento: '',
    numId: '',
    nombre: '',
    departamento: '',
    nombreDepartamento: '',
    municipio: '',
    nombreMunicipio: '',
    direccion: '',
    email: '',
    chipsEmail: [],
    telefono: '',
    actividad: '',
    nrc: '',
    descripcion: '',
    checkCF: false,
    checkContribuyente: false,
    checkExentoImpuesto: false,
    validacionMonto25000: false,
    correocc: '',
  },
  errorsFormCliente: {
    fecha: '',
    tipoDocumento: '',
    numId: '',
    nombre: '',
    departamento: '',
    municipio: '',
    direccion: '',
    email: '',
    telefono: '',
    actividad: '',
    nrc: '',
    descripcion: '',
  },
  formProductos: {
    tipo: 'p',
    checkNoIva: false,
    descripcion: '',
    cantidad: '',
    precioConIva: '',
    subtotalConIva: '0.00',
    ventasGravadas: '0.00',
    precio: '',
    tipoDescuento: 'porcentaje',
    descuento: '0',
    cantidadDescuento: '0.00',
    subtotal: '0.00',
    total: '0.00',
    totalImpuesto1: '0.00',
    totalImpuesto2: '0.00',
    impuesto1: '0.00',
    impuesto2: '0.00',
    totalConImpuesto1: '0.00',
    subTotalConImpuesto1: '0.00',
    totalConImpuesto1Desc: '0.00',
    unidadMedida: '59'
  },
  errorsFormProductos: {
    tipo: '',
    descripcion: '',
    cantidad: '',
    precio: '',
    tipoDescuento: '',
    descuento: '',
    cantidadDescuento: '',
    subtotal: '',
    total: '',
  },
  formSucursal: {
    sucursal: '',
    serie: '',
    datosSucursal: null,
    datosSerie: null,
  },
  errorsFormSucursal: {
    sucursal: '',
    serie: '',
  },
  productoSeleccionado: null,
  productoEdit: {
    tipo: 'p',
    checkNoIva: false,
    descripcion: '',
    cantidad: '',
    precio: '',
    tipoDescuento: 'porcentaje',
    descuento: '',
    cantidadDescuento: '0.00',
    subtotal: '0.00',
    total: '0.00',
    totalImpuesto1: '0.00',
    totalImpuesto2: '0.00',
    impuesto1: '0.00',
    impuesto2: '0.00',
    totalConImpuesto1: '0.00',
    subTotalConImpuesto1: '0.00',
    totalConImpuesto1Desc: '0.00',
  },
  formProductosEdit: {
    tipo: 'p',
    checkNoIva: false,
    descripcion: '',
    cantidad: '',
    precioConIva: '',
    subtotalConIva: '0.00',
    ventasGravadas: '0.00',
    precio: '',
    tipoDescuento: 'porcentaje',
    descuento: '',
    cantidadDescuento: '0.00',
    subtotal: '0.00',
    total: '0.00',
  },
  errorsFormProductosEdit: {
    tipo: '',
    descripcion: '',
    cantidad: '',
    precio: '',
    tipoDescuento: '',
    descuento: '',
    cantidadDescuento: '',
    subtotal: '',
    total: '',
  },
  arrayProductos: [],
  calculosArrayProductos: {
    subtotal: '0.00',
    descuento: '0.00',
    total: '0.00',
    totalCantidad: '0.00',
    totalImpuesto1: '0.00',
    totalImpuesto2: '0.00',
    totalIvaPercibido: '0.00',
    totalRetencionRenta: '0.00',
    totalMontoOperacion: '0.00',
    totalPagar: '0.00',
    subTotalConImpuesto1: '0.00',
    totalConImpuesto1: '0.00',
    totalConRetecion: '0.00',
  },
  modals: {
    activeQuitarTodo: false,
    activeEliminarUno: false,
    activeEditar: false,
    activeEmitirFactura: false,
    activeFacturaEmitida: false,
    activeImpresion: false,
    activeEmail: false,
    activeAnular: false,
    activeConfirmEmptyData: false,
    activeInfoCliente: false,
    infoCliente: {},
  },
  datosEmisor: {},
  datosFacturaRes: {},
  facturaEmitda: false,
  opcionesActiva: false,
  catalogoSucursal: [],
  catalogoSerie: [],
  sucursalesCargadas: false,
  datosUUID: null,
  anulado: false,
  impresionModoTicket: false,
  formObservaciones: {
    referencia: '',
    observaciones: '',
    mostrarObservacionesPdf: true,
    incluirObservacionesCorreo: true,
  },
}

export const facturacionInitialState2 = JSON.parse(JSON.stringify(facturacionInitialState))

export const ningunoRequeridoCF = {
  tipoDocumento: false,
  numId: false,
  nombre: true,
  departamento: false,
  municipio: false,
  direccion: false,
  email: false,
  telefono: false,
  actividad: false,
}
export const requeridosInicial = {
  tipoDocumento: true,
  numId: false,
  nombre: false,
  departamento: false,
  municipio: false,
  direccion: false,
  email: false,
  telefono: false,
  actividad: false,
}

export const requeridoDuiNitCF = {
  tipoDocumento: true,
  numId: true,
  nombre: false,
  departamento: false,
  municipio: false,
  direccion: false,
  email: false,
  telefono: false,
  actividad: false,
}

export const requeridosOtrosCF = {
  tipoDocumento: true,
  numId: true,
  nombre: false,
  departamento: false,
  municipio: false,
  direccion: false,
  email: false,
  telefono: false,
  actividad: false,
}

export const requeridosSinDocumentoCF = {
  tipoDocumento: true,
  numId: false,
  nombre: true,
  departamento: false,
  municipio: false,
  direccion: false,
  email: false,
  telefono: false,
  actividad: false,
}

export const requeridosGranContribuyente = {
  tipoDocumento: true,
  numId: true,
  nombre: true,
  departamento: true,
  municipio: true,
  direccion: true,
  email: false,
  telefono: true,
  actividad: false,
}

export const requeridosValidacion25000 = {
  tipoDocumento: true,
  numId: true,
  nombre: true,
  departamento: false,
  municipio: false,
  direccion: false,
  email: false,
  telefono: false,
  actividad: false,
}